import React from 'react';
import {Box, Typography} from '@mui/material';
import SearchNotFoundIcon from '../../assets/search-not-found.svg';

/**
 * Document404 - 404 error component for document not found
 *
 * Displays a user-friendly message when a document cannot be found.
 * Note: AppBar is already rendered at a higher level, so this component
 * only renders the error content.
 */
const Document404 = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
      }}
    >
      <img
        src={SearchNotFoundIcon}
        alt="Document not found"
        width={64}
        height={64}
      />
      <Typography
        variant="h4"
        sx={{
          textAlign: 'center',
        }}
      >
        Document not found
      </Typography>
      <Typography
        sx={{
          fontSize: '16px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: '150%',
          letterSpacing: '-0.14px',
          color: '#819190',
          textAlign: 'center',
        }}
      >
        We couldn&apos;t find this document. Please check the link or contact
        your administrator.
      </Typography>
    </Box>
  );
};

export default Document404;
